import { render } from "./BaseSelectInput.vue?vue&type=template&id=f59194d6&scoped=true"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js"

import "./BaseSelectInput.vue?vue&type=style&index=0&id=f59194d6&scoped=true&lang=css"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59194d6"]])

export default __exports__